module.exports = __webpack_public_path__ + "media/fluidBall.5eaed6dc.mp4";